import { string } from 'prop-types';
import React from 'react';
import { Author, QuoteWrapper } from './styled';

const Quote = ({
  children,
  author
}) => {
  if (children) {
    return /*#__PURE__*/React.createElement(QuoteWrapper, null, /*#__PURE__*/React.createElement("blockquote", null, children), author && /*#__PURE__*/React.createElement(Author, {
      className: "author"
    }, author));
  }

  return null;
};

Quote.propTypes = {
  children: string.isRequired,
  author: string
};
export default Quote;